"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ViewportAction = ViewportAction;
exports.enhance = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _withStateHandlers = _interopRequireDefault(require("recompose/withStateHandlers"));

var _lifecycle = _interopRequireDefault(require("recompose/lifecycle"));

var _defaultProps = _interopRequireDefault(require("recompose/defaultProps"));

var _dom = require("./utils/dom");

var VIEWPORT_EVENTS = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'load'];
var DEFAULT_DELAY = 1000;
var enhance = (0, _compose["default"])((0, _defaultProps["default"])({
  delay: DEFAULT_DELAY,
  percentVisible: 100
}), (0, _withStateHandlers["default"])(function () {
  return {
    el: null,
    isVisible: false,
    triggered: false
  };
}, {
  getRef: function getRef() {
    return function (element) {
      return {
        el: element
      };
    };
  },
  setTriggered: function setTriggered() {
    return function () {
      return {
        triggered: true
      };
    };
  },
  handleViewportChange: function handleViewportChange(_ref, _ref2) {
    var el = _ref.el,
        triggered = _ref.triggered;
    var percentVisible = _ref2.percentVisible;
    return function () {
      return triggered ? null : {
        isVisible: (0, _dom.isElementVisible)(el, percentVisible)
      };
    };
  }
}), (0, _lifecycle["default"])({
  componentDidMount: function componentDidMount() {
    (0, _dom.on)(VIEWPORT_EVENTS, this.props.handleViewportChange);
    this.props.handleViewportChange();
  },
  componentWillUnmount: function componentWillUnmount() {
    (0, _dom.off)(VIEWPORT_EVENTS, this.props.handleViewportChange);
    clearTimeout(this.triggerTimeout);
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _this = this;

    if (this.props.triggered) {
      return;
    }

    if (!prevProps.isVisible && this.props.isVisible) {
      this.triggerTimeout = setTimeout(function () {
        _this.props.setTriggered();

        _this.props.onVisible(_this.props.delay);
      }, this.props.delay);
    }

    if (prevProps.isVisible && !this.props.isVisible) {
      clearTimeout(this.triggerTimeout);
    }
  }
}));
exports.enhance = enhance;

function ViewportAction(_ref3) {
  var getRef = _ref3.getRef,
      children = _ref3.children,
      className = _ref3.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: getRef,
    className: className
  }, children);
}

ViewportAction.propTypes = {
  getRef: _propTypes["default"].func,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string
};

var _default = enhance(ViewportAction);

exports["default"] = _default;